import { render } from "./LoginNinja.vue?vue&type=template&id=30d18915&ts=true"
import script from "./LoginNinja.vue?vue&type=script&lang=ts"
export * from "./LoginNinja.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__